import { getNtiUrl } from "../../header/utils";
import RlCloudSandboxMalwareConfigurationRedirectLink from "./RlCloudSandboxMalwareConfigurationRedirectLink";
import { MalwareConfigurationsConfig } from "./types";

const MalwareConfigValue = ({ value }: { value: string | number | object }) => {
  if (typeof value === "string" && getNtiUrl(value)) {
    return <RlCloudSandboxMalwareConfigurationRedirectLink url={value} />;
  }
  if (typeof value === "number") {
    return <>{value.toString()}</>;
  }
  return <>{JSON.stringify(value, null, "\t")}</>;
};

export const RlCloudSandboxMalwareConfigSchema = {
  fields: [
    {
      name: "name",
      displayTitle: "Name",
      sortable: true,
      style: { width: "20%", borderRight: "1px solid #dedede" }
    },
    {
      name: "value",
      displayTitle: "Value",
      sortable: false,
      component: (item: MalwareConfigurationsConfig) => (
        <div className={"flex flex-column gap-5"}>
          {item.value.map((value, index) => (
            <pre key={`${item.title}_${item.name}_${value}_${index}`}>
              <MalwareConfigValue value={value} />
            </pre>
          ))}
        </div>
      ),
      style: { width: "80%" }
    }
  ]
};
